import "./Intro.css";

import { useEffect, useState } from "react";
import { getUploadFileUrl } from "../../consts";
import axios_with_token from "../../axios_with_token";
import { useData } from "../../consts";
import { useRcd, getErrMsgs, regUses } from "../../axios_with_token";

export function Carousel(props){
    // get carousel data
    const cId = `carouselId-${window._ww_tools.uuidv4()}`;
    const carouselData = props.carouselData;

    useEffect(_=>{
        // [] make crousel start automatically
        document.querySelector(`#${cId} .carousel-control-next`).click();
    })

    return <div
        id={cId}
        // slide carousel-
        className={`carousel ${props.anim || "carousel-fade"}`}
        style={{
            "overflow":"hidden",
            "backgroundColor":"darkgray"
        }}
        data-bs-ride="carousel"
        data-bs-interval={props.interval || 6000}

        // data-ride="carousel"
        // data-interval="1000"
    >
        <div className="carousel-indicators">
            {carouselData&&carouselData.map((carouselDef, cIdx)=>{
                return <button
                    key={cIdx}
                    type="button"
                    data-bs-target={`#${cId}`}

                    className={(cIdx===0?"active":"")}
                    aria-current={(cIdx===0?"true":"")}

                    data-bs-slide-to={(cIdx+1)%carouselData.length}
                    aria-label={"Slide " + cIdx}
                ></button>;
            })}
            {/* <button type="button" data-bs-target={`#${cId}`} data-bs-slide-to="1" aria-label="Slide 2"></button>
            <button type="button" data-bs-target={`#${cId}`} data-bs-slide-to="2" aria-label="Slide 3"></button> */}

        </div>

        <div className="carousel-inner">
            {carouselData&&carouselData.map((carouselDef, cIdx)=>{
                console.log('carouselDef:', carouselDef);
                return <div
                    className={"carousel-item "+(cIdx===0?"active":"")}
                    key={cIdx}
                    style={{
                        "height":"30em",
                        "backgroundPosition": "center center",
                        "backgroundSize":"cover", 
                        "backgroundImage":`url(${getUploadFileUrl((JSON.parse(carouselDef.img)[0]||{}).url)})`
                    }}
                >
                    <div className="carousel-caption d-none d-md-block">
                        <section id="intro">
                            <div className="jumbotron p-5 text-white rounded">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-12"
                                            dangerouslySetInnerHTML={{__html: carouselDef.html}}
                                        >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    {/* <img src="https://static01.nyt.com/images/2023/03/19/fashion/GIRLS-REWATCH/GIRLS-REWATCH-superJumbo.jpg" className="d-block w-100" alt="..." /> */}
                </div>;
            })}
        </div>

        <button className="carousel-control-prev" type="button" data-bs-target={`#${cId}`} data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target={`#${cId}`} data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
        </button>
    </div>
}

export function HomePanel(props){
    const data = props.homePanelData || {};
    // const subPanels = data.subPanels;
    // let subPanels = [];
    // try{
    //     subPanels = JSON.parse(data.subPanels || "[]");
    // }catch(err){

    // }
    
    return <section id="intro" className="container-fluid mt-1 clearfix" style={{"overflow":"hidden"}}>
        {(!data.position||(data.position==="left"))&&<div className="mt-5 text-white rounded">
            <div className="">
                <div className="row pt-0">
                    <div className="col-md-5">
                        <h1 className="text-body playfair-400">{data.title||""}</h1>
                        <p className="lead text-secondary">{data.content||""}</p>
                        <a className="btn btn-primary" href="#">check for details now</a>
                    </div>

                    <div className="col-md-7">
                        <div className="container">
                        <div className="row mb-3">
                            {(data.subPanels||[]).map((subPanelDef,idx)=>{
                                // [
                                //     "https://suplinen.com/wp-content/uploads/2024/05/Quality-hotel-linens.jpg",
                                //     "https://cdn11.bigcommerce.com/s-rpzf45a/images/stencil/500x659/products/2802/9393/reverie-organic__91162.1537037295.png?c=2",
                                //     "https://m.media-amazon.com/images/I/71BjC+kueJL._US500_.jpg",
                                //     "https://www.midj.com/images/uploads/blog/01-arredo-hotel-midj.jpg"
                                // ]
                                // let imgUrl;
                                // try{
                                //     imgUrl = (JSON.parse(subPanelDef.img || "[]")[0] || {}).url;
                                // }catch(err){
                                // }
                                return <div key={"slot-"+idx} className="col-md-6">
                                    <div className="card m-2">
                                        <div  className="card-img-top" style={{"height":"10em", 
                                            "backgroundPosition": "center top",
                                            "backgroundSize":"cover",
                                            "backgroundImage":`url(${(subPanelDef.img.length>0)&&getUploadFileUrl(subPanelDef.img[0].url)})`
                                        }} ></div>
                                        {/* <img src="https://www.marthastewart.com/thmb/XFay_tPSlk423zZVSxrPC8h9bqs=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/HTH0149-HowtoFoldBathTowels-2-74522e8f13e44de1987dc814191dfacf.jpg" className="card-img-top" alt="..." /> */}
                                            <div className="card-body">
                                                <h5 className="card-title">Card title</h5>
                                                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                                <a href="#" className="btn btn-primary">View detail ...</a>
                                            </div>
                                    </div>
                                </div>})}
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>}

        {(data.position==="right")&&<div className="mt-5 text-white rounded">
            <div className="">
                <div className="row pt-0">
                    <div className="col-md-7">
                        <div className="container">
                        <div className="row mb-3">
                            {(data.subPanels||[]).map((subPanelDef,idx)=>{
                                // [
                                //     "https://suplinen.com/wp-content/uploads/2024/05/Quality-hotel-linens.jpg",
                                //     "https://cdn11.bigcommerce.com/s-rpzf45a/images/stencil/500x659/products/2802/9393/reverie-organic__91162.1537037295.png?c=2",
                                //     "https://m.media-amazon.com/images/I/71BjC+kueJL._US500_.jpg",
                                //     "https://www.midj.com/images/uploads/blog/01-arredo-hotel-midj.jpg"
                                // ]
                                // let imgUrl;
                                // try{
                                //     imgUrl = (JSON.parse(subPanelDef.img || "[]")[0] || {}).url;
                                // }catch(err){
                                // }
                                return <div key={"slot-"+idx} className="col-md-6">
                                    <div className="card m-2">
                                        <div  className="card-img-top" style={{"height":"10em", 
                                            "backgroundPosition": "center top",
                                            "backgroundSize":"cover",
                                            "backgroundImage":`url(${(subPanelDef.img.length>0)&&getUploadFileUrl(subPanelDef.img[0].url)}})`
                                        }} ></div>
                                        {/* <img src="https://www.marthastewart.com/thmb/XFay_tPSlk423zZVSxrPC8h9bqs=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/HTH0149-HowtoFoldBathTowels-2-74522e8f13e44de1987dc814191dfacf.jpg" className="card-img-top" alt="..." /> */}
                                            <div className="card-body">
                                                <h5 className="card-title">Card title</h5>
                                                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                                <a href="#" className="btn btn-primary">View detail ...</a>
                                            </div>
                                    </div>
                                </div>})}
                        </div>
                        </div>
                    </div>

                    <div className="col-md-5">
                        <h1 className="text-body playfair-400">{data.title||""}</h1>
                        <p className="lead text-secondary">{data.content||""}</p>
                        <a className="btn btn-primary" href="#">check for details now</a>
                    </div>
                </div>
            </div>
        </div>}

        {(data.position==="center")&&<div className="mt-5 text-white rounded">
            <div className="">
                <div className="row pt-0 align-self-md-center">
                    <h1 className="text-body playfair-400">{data.title||""}</h1>
                    <p className="lead text-secondary">{data.content||""}</p>
                    <a className="btn btn-primary align-items-md-center" href="#" style={{"flex":"0.25"}}>check for details now</a>
                </div>
                <div className="row mb-3">
                    {(data.subPanels||[]).map((subPanelDef,idx)=>{
                        // [
                        //     "https://suplinen.com/wp-content/uploads/2024/05/Quality-hotel-linens.jpg",
                        //     "https://cdn11.bigcommerce.com/s-rpzf45a/images/stencil/500x659/products/2802/9393/reverie-organic__91162.1537037295.png?c=2",
                        //     "https://m.media-amazon.com/images/I/71BjC+kueJL._US500_.jpg",
                        //     "https://www.midj.com/images/uploads/blog/01-arredo-hotel-midj.jpg"
                        // ]
                        // let imgUrl;
                        // try{
                        //     imgUrl = (JSON.parse(subPanelDef.img || "[]")[0] || {}).url;
                        // }catch(err){
                        // }
                        return <div key={"slot-"+idx} className="col">
                            <div className="card m-2">
                                <div  className="card-img-top" style={{"height":"10em", 
                                    "backgroundPosition": "center top",
                                    "backgroundSize":"cover",
                                    "backgroundImage":`url(${(subPanelDef.img.length>0)&&getUploadFileUrl(subPanelDef.img[0].url)})`
                                }} ></div>
                                {/* <img src="https://www.marthastewart.com/thmb/XFay_tPSlk423zZVSxrPC8h9bqs=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/HTH0149-HowtoFoldBathTowels-2-74522e8f13e44de1987dc814191dfacf.jpg" className="card-img-top" alt="..." /> */}
                                    <div className="card-body">
                                        <h5 className="card-title">{subPanelDef.title||""}</h5>
                                        <p className="card-text">{subPanelDef.content||""}</p>
                                        <a href={subPanelDef.url||"#"} className="btn btn-primary">View detail ...</a>
                                    </div>
                            </div>
                        </div>})}
                </div>
            </div>
        </div>}
    </section>
}

export default function Intro({}){

    const {regUse, isLoading, hasError, getErrMsgs} = regUses();

    const {data:siteData} = regUse(useRcd('site', 1));

    if (isLoading()) {
        return <div>Loading...</div>;
    }
    
    if(hasError()) {
        return <div>[RcdEditDialog] Error: {getErrMsgs().map(((errMsg, errMsgIdx)=><h3 key={`${errMsgIdx}`}>{errMsg}</h3>))}</div>;
    }

    const carouselData = JSON.parse(siteData.homeCarousel || "[]");
    const homePanels = JSON.parse(siteData.homePanels || "[]");

    return <>
        <Carousel 
            carouselData={carouselData}
        />

        {homePanels&&homePanels.map((homePanelData, hompanelIdx)=>{
            try{
                // parse sub panel
                homePanelData.subPanels = JSON.parse(homePanelData.subPanels || "[]");
                // parse sub panel img
                Object.values(homePanelData.subPanels).forEach(subPanel=>{
                    subPanel.img = JSON.parse(subPanel.img);
                })
            }catch(err){

            }
            return <HomePanel 
                key={hompanelIdx}
                homePanelData={homePanelData}
            />
        })};

        <div className="clearfix">

        </div>
        
    </>;

}

export function BAKIntro(props){
    const [carouselData, setCarouselData] = useState(false);
    const [homePanels, setHomePanels] = useState(false);
    const {siteData} = useData();

    useEffect(_=>{
        setCarouselData(JSON.parse(siteData.homeCarousel || "[]"));
        setHomePanels(JSON.parse(siteData.homePanels || "[]"));
    }, [siteData])

    return <>
        <Carousel 
            carouselData={carouselData}
        />

        {homePanels&&homePanels.map((homePanelData, hompanelIdx)=>{
            try{
                // parse sub panel
                homePanelData.subPanels = JSON.parse(homePanelData.subPanels || "[]");
                // parse sub panel img
                Object.values(homePanelData.subPanels).forEach(subPanel=>{
                    subPanel.img = JSON.parse(subPanel.img);
                })
            }catch(err){

            }
            return <HomePanel 
                key={hompanelIdx}
                homePanelData={homePanelData}
            />
        })};

        <div className="clearfix">

        </div>
        
    </>;
}